import { Button } from '@design-system';
import classNames from 'classnames';
import { Modal } from '../Modal/Modal';
import { IDeleteConfirmationModal } from './DeleteConfirmationModal.types';
import styles from './DeleteConfirmationModal.module.scss';

export const DeleteConfirmationModal: React.FC<IDeleteConfirmationModal> = (props) => {
  const {
    title,
    confirmMessage,
    cancelText = 'CANCEL',
    confirmText = 'YES, DELETE',
    className = '',
    onCancel,
    onConfirm,
    visible,
  } = props;
  return (
    <Modal
      title={title}
      className={classNames(className, styles['ds-delete-confirmation-modal-content'])}
      visible={visible}
      onModalClosed={onCancel}
    >
      <div>
        <p className={styles['confirm-message']}>{confirmMessage}</p>
        <div className={styles['actions-container']}>
          <Button
            variant="outlined"
            size="medium"
            styleType="secondary"
            onClick={onCancel}
            className="md:!text-[14px] w-full md:w-[unset] !h-[40px] md:!h-[32px]"
          >
            {cancelText}
          </Button>
          <Button
            variant="outlined"
            styleType="danger"
            onClick={onConfirm}
            className="md:!text-[14px] w-full md:w-[unset] !h-[40px] md:!h-[32px]"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
